import React from 'react';
import { NavLink } from 'react-router-dom';
import {toggleMenu, toggleMenu2} from '../js/navbar';
// import {sendWhatsAppMessage} from "../js/whatsapp";

export const HeaderNav = () => {
    return (
        <header className="header">
            <div className="logo">
                <img src="../devs-ndesigns-logo.png" alt="Logo"></img>
            </div>

            <nav>
                <div className="menu-icon" onClick={toggleMenu}>
                    <span className='line'></span>
                    <span className='line'></span>
                    <span className='line'></span>
                </div>
                <ul className="nav-links">
                    <li>
                        <NavLink onClick={toggleMenu2} to="/start" className={({isActive}) => isActive ? "active":""}>Inicio</NavLink>
                    </li>
                    <li>
                        <NavLink onClick={toggleMenu2} to="/portfolio" className={({isActive}) => isActive ? "active":""}>Portafolio</NavLink>
                    </li>
                    <li>
                        <NavLink onClick={toggleMenu2} to="/services" className={({isActive}) => isActive ? "active":""}>Servicios</NavLink>
                    </li>
                    <li>
                        <NavLink onClick={toggleMenu2} to="/resume" className={({isActive}) => isActive ? "active":""}>Curriculum</NavLink>
                    </li>
                    <li>
                        <NavLink onClick={toggleMenu2} to="/contact" className={({isActive}) => isActive ? "active":""}>Contacto</NavLink>
                    </li>
                </ul>

            </nav>
        </header>
    )
}
